module.exports = __webpack_public_path__ + "img/logo.8ab3311c.png";